export default function(){
    $(function () {
        $("#select-monitor").on('change', function () {
            $("#monitor-selector-form").trigger('submit');
        });
    });
}